// @flow

import { Link } from 'react-router-dom';

import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectWhoisUrl } from 'src/modules/config';

type Props = { fqdn: string };

export function WhoisLink({ fqdn }: Props): React.MixedElement {
  const { __ } = useTranslator();
  const whoisURL = useAppSelector(selectWhoisUrl);

  return (
    <Link target="_blank" rel="noopener" to={`${whoisURL}?search=${fqdn}`}>
      {__('See WHOIS')}
    </Link>
  );
}
